<template>
    <div
        class="gcmcn-card-gradient"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="min-height: 300px;"
    >
        <!-- v-loading="loading" -->
        <gcmcn-filters
            :filter-values="[selectedSortType, searchFilter]"
            @reset-filters="resetFilters"
            style="margin-top: 0;"
        >
            <dropdown
                name="Sort"
                :multiple="false"
                :list="$store.getters.sortTypeList"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                @on-select-item="selectedSortType = $event"
            ></dropdown>
            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
        </gcmcn-filters>
        <template v-if="availableTakers.length > 0">
            <taker-configuration
                v-loading="loadingConfiguration"
                element-loading-background="rgba(0, 0, 0, 0.5)"
                v-for="taker in availableTakers"
                :key="taker.uid"
                :taker="taker"
                :feed-resource="feedResource"
                :configurations="configurationsRelatedToFeedRessource"
                @create-configuration="onCreateconfiguration"
                @on-configuration-cancelled="triggerRefresh"
                @trigger-refresh="triggerRefresh"
            ></taker-configuration>
        </template>
        <div v-else class="list-empty">
            No taker(s).
        </div>
        <subscribe-modal
            ref="subscribeModal"
            @on-configuration-created="triggerRefresh"
        ></subscribe-modal>
    </div>
</template>

<script>
import TakerConfiguration from './taker-configuration.vue';
import { mapGetters } from 'vuex';
import {
    SubscribeModal,
    Dropdown,
    SearchFilter,
    GcmcnFilters,
    GcmcnModal
} from 'gcmcn-common';
export default {

    name: 'FeedResourceConfigurations',
    components:{
        SubscribeModal,
        Dropdown,
        SearchFilter,
        GcmcnFilters,
        TakerConfiguration,
        GcmcnModal,
    },
    props:{
        feedResource:{
            type: Object,
            required: true,
        },
        feedResources:{
            type: Array,
            required: true,
        },
        configurations:{
            type: Array,
            required: true
        },
        universe: {
            required: true,
            type: Object,
        }
    },
    data () {
        return {
            loadingConfiguration: false,
            selectedSortType: 'asc',
            searchFilter: '',
            displayModal: false,
            takerRegion: null,
        };
    },
    computed:{
        ...mapGetters([
            'takers',
            'awsregionsByUid'
        ]),
        configurationsRelatedToFeedRessource(){
            return this.configurations.filter(
                configuration => configuration.feed_resource_uid === this.feedResource.uid
            );
        },
        feedResourceRelatedRegions(){
            return this.feedResource.delivery_aws_regions_uid;
        },
        availableTakers(){
            let takers = [...this.takers];
            if(this.feedResource.scopes && this.feedResource.scopes.entity_uid){
                takers = takers.filter(
                    taker =>
                        this.feedResource.scopes.entity_uid === taker.scopes.entity_uid
                );
            }
            if(this.searchFilter.length > 0){
                let searchFilter = this.searchFilter.toLowerCase();
                takers = takers.filter((taker) => taker.name.toLowerCase().includes(searchFilter));
            }
            if(this.selectedSortType.length > 0){
                takers.sort((a,b) => {
                    return b.name.toLowerCase().localeCompare(a.name.toLowerCase());
                });
                if(this.selectedSortType === 'asc'){
                    takers.reverse();
                }
            }
            return takers;
        }
    },
    methods:{
        onCreateconfiguration(taker, takerGroup) {
            if(!this.feedResourceRelatedRegions.includes(taker.aws_region_uid)){
                let takerRegion = this.awsregionsByUid(taker.aws_region_uid).display_name
                this.$notify({
                    message: `Please associate this taker’s region "${takerRegion}" to the feed resource first`,
                    type: 'warning',
                    customClass: 'dark-notification',
                })
            }else{
                this.loadingConfiguration = true;
                this.triggerRefresh();
                this.loadingConfiguration = false;
                this.$refs.subscribeModal.open(
                    this.feedResource,
                    this.feedResources,
                    'feedResource',
                    this.configurations,
                    this.universe.name,
                    taker,
                    takerGroup,
                    null,
                    'feedResourceConfigurations'
                );
            }

        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
        },
        triggerRefresh(){
            this.$emit('trigger-refresh');
        }
    }
};
</script>

<style lang="scss">
    .dark-notification{
        background-color: #333333;
        color: #FFFFFF;
        border: none;
        .el-notification__group{
            .el-notification__content{
                color: #FFFFFF;

            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResources/feedResourceDetails/feed-resource-configurations.vue